import axios from 'axios';

interface PublicConfig {
  hashidsSalt: string;
  captchaSiteKey: string;
}

let _config: PublicConfig = {
  hashidsSalt: '',
  captchaSiteKey: '',
};

let _fetched = false;

export const fetchPublicConfig = async (): Promise<PublicConfig> => {
  if (_fetched) return _config;
  const response = await axios.get<PublicConfig>(
    `${process.env.REACT_APP_PTS_API}/v1/config/public`
  );
  _config = response.data;
  _fetched = true;
  return _config;
};

export const getPublicConfig = (): PublicConfig => _config;
